export default [
  {
    path: '',
    component: () => import('./AmbitusDetector.vue'),
    name: 'Ambitus',
    meta: {
      title: "Réglage de la plage vocale",
    },
  },
];
